import { getUUID } from "@/utils";
import { merge, get } from "lodash-es";

const clickCreateEdgeOpt = {
  edge: null,
  getEvents() {
    return {
      "node:click": "onClick",
      mousemove: "updateEndPoint",
      "edge:click": "cancelCreate",
      "canvas:click": "cancelCreate",
      "combo:click": "onClick",
    };
  },
  // FLOW-DOC:
  // 点击 node 的事件在此处包装
  calcShouldBegin(ev) {
    const { target, item } = ev;
    const targetName = target.get("name") || "";
    const nodeType = get(item.getModel(), "nodeData.nodeType");
    const edges = item.getEdges();
    if (nodeType === "startNode" && edges.length) {
      return false;
    }
    if (
      ["source-hot-area", "anchor-point"].includes(targetName) &&
      !this.graph._addingEdge &&
      !this.graph._addingEdgeByClick
    ) {
      return true;
    }
  },

  xCalcShouldEnd({ item }, cEdge) {
    const itemType = item.getType();
    if (itemType === "node" && cEdge) {
      const currentNode = item;
      const currentNodeModel = currentNode.getModel();
      // 终点不可以是开始节点, 不可以是自己
      // DESC: 结束点不可以是开始点
      if (currentNodeModel.type === "start-node") {
        console.log("TIP: 结束不可以是 start-node");
        return false;
      }

      // DESC: 结束点不可以是自己
      const currentSource = cEdge.getSource();
      if (currentSource === currentNode) {
        console.log("TIP: 结束不可以是自己");
        return true;
      }

      // DESC: 起始点不能有多个 edge ,由后续创建完后的 验证环节去掉
      // if (currentSource.getModel().type === "start-node") {
      //   if (currentSource.getEdges().length > 1) {
      //     return false;
      //   }
      // }

      const currentSourceEdges = currentSource.getEdges();

      // 根据类型判断反方向连线
      const existing = currentSourceEdges.find((edge) => {
        if (edge === cEdge) {
          //此 edge 是当前 edge
          return false;
        }
        const target = edge.getTarget();
        const source = edge.getSource();
        if (target === currentNode) {
          return true;
        }
        if (source === currentNode) {
          // 允许环形回路
          // return true;
          return false;
        }
      });
      if (existing) {
        return false;
      }
      return true;
    }
    return false;
  },

  // 可以结束 edge
  calcShouldEnd({ item }, cEdge) {
    return true;
  },

  /**
   * @description 绘制完成
   */
  drawEdgeEnd(ev) {
    if (this.key && !this.keydown) return;
    if (this.edge && this.calcShouldEnd(ev, this.edge)) {
      const getEdgeConfig = this.getEdgeConfig;
      const node = ev.item;
      const model = node.getModel();
      let edgeConfig;
      if (getEdgeConfig) {
        edgeConfig = getEdgeConfig(
          {
            source: this.source,
            target: model.id,
          },
          this,
          "createEnd",
        );
      } else {
        edgeConfig = this.edgeConfig;
      }

      const updateCfg = {
        target: model.id,
        ...edgeConfig,
        // DESC: 2024-07-16 source 点位永远在下部中间
        sourceAnchor: model.type === "start-node" ? 0 : 1,
        // DESC: 2024-07-16 target 点位，在上部中间
        targetAnchor: 0,
      };

      // 更新边
      this.updateEdgeStack(updateCfg);
      this.createEnd();
    } else {
      // 无法创建 edge ，删除 edge， 结束创建流程
      this.cancelCreate();
      this.createEnd();
    }
  },
  // 点击了
  // 如果边的起点没有指定，则根据起点创建新边；
  // 如果起点已经指定而终点未指定，则指定终点
  onClick(ev) {
    if (this.key && !this.keydown) return;
    const node = ev.item;
    const graph = this.graph;
    const model = node.getModel();
    const getEdgeConfig = this.getEdgeConfig;

    // 如果起点已经指定而终点未指定，则指定终点

    // FLOW-DOC: 先判断点击的是否是创建边的启动元素
    if (this.calcShouldBegin(ev)) {
      // 如果边的起点没有指定，则根据起点创建新边
      // 获取自定义 edge 配置
      let edgeConfig;
      if (getEdgeConfig) {
        edgeConfig = getEdgeConfig(
          {
            source: model.id,
            target: model.id,
          },
          this,
          "createStart",
        );
      } else {
        edgeConfig = this.edgeConfig;
      }

      this.edge = graph.addItem(
        "edge",
        {
          id: "node-" + getUUID(),
          source: model.id,
          target: model.id,
          ...edgeConfig,
          // edgeData: {
          //   edgeType: "select",
          //   data: {},
          // },
          // label: "选择条件  ▼",
        },
        false,
      );
      this.edge.setState("updating", true);
      // this.graph.setItemState(this.edge, "updating", true);
      this.source = model.id;
      this.startCreate();
      // 暂时将该边的 capture 设置为 false，这样可以拾取到后面的元素
      this.edge.getKeyShape().set("capture", false);
      // 阻止其响应鼠标点击事件
    } else {
      this.drawEdgeEnd(ev);
    }
  },
  updateEdgeStack(updateCfg) {
    const graph = this.graph;
    graph.emit("edge:update");
    graph.updateItem(this.edge, updateCfg, false);
    if (graph.get("enabledStack")) {
      const addedModel = {
        ...this.edge.getModel(),
        itemType: "edge",
      };
      const after = {};
      after.edges = [addedModel];
      graph.pushStack("add", {
        before: {},
        after,
      });
    }

    // 这个时候才emit afterupdateEdge, 自动布局
    // graph.emit("edge:afterUpdate", {
    //   item: this.edge,
    // });

    // 恢复默认颜色
    this.createEnd();
  },
  cancelCreate() {
    if (this.edge && !this.edge.destroyed) {
      this.graph.removeItem(this.edge, false);
      this.createEnd();
    }
  },
  // 创建结束的恢复函数
  createEnd() {
    if (this.edge) {
      // FIX: 可能存在其他地方被删除的情况，执行 stopCreate。此时会设置不了 state.
      if (!this.edge.destroyed) {
        this.edge.getKeyShape().set("capture", true);
        // this.edge.setState("active", false);
        this.edge.setState("updating", false);
      }
      this.edge = null;
      const edgeGroup = this.graph.get("edgeGroup");
      if (edgeGroup) {
        edgeGroup.toBack();
        edgeGroup.set("capture", true);
        this.graph.paint();
      }
      this.graph.emit("xEdge:addOrUpdateEnd", { item: this.edge });
    }
    setTimeout(() => {
      this.graph._addingEdgeByClick = false;
    }, 0);
  },
  startCreate() {
    const edgeGroup = this.graph.get("edgeGroup");
    if (edgeGroup) {
      edgeGroup.toFront();
      this.graph.paint();
    }
    this.graph._addingEdgeByClick = true;
  },
  // 边的起点已经确定，边的末端跟随鼠标移动
  updateEndPoint(ev) {
    if (this.key && !this.keydown) return;
    if (this.edge && this.edge.destroyed) {
      this.cancelCreate();
      return;
    }

    // // 若此时 source 节点已经被移除，结束添加边
    // if (!this.graph.findById(this.source)) {
    //   this.createEnd();
    //   return;
    // }

    if (this.edge) {
      const point = { x: ev.x, y: ev.y };
      // 更新边的终点为鼠标位置
      this.graph.updateItem(
        this.edge,
        {
          target: point,
        },
        false,
      );
      this.graph.emit("edge:update");
    }
  },
};

export const getClickCreateEdgeOpt = (opt) => {
  return merge({}, clickCreateEdgeOpt, opt);
};
